export function exportNotice(asset) {
  if (asset?.project_export?.status === "queued") return "；文件已排队回存 NAS，稍后可见，无需重复上传。";
  if (asset?.project_export?.status === "pending") return "；回存暂不可用，原上传已保留，后台将自动重试。";
  return "";
}
